import { useState } from 'react';
import { Box, Typography } from '@mui/material';

const FAQ_ITEMS = [
  {
    q: 'מה זו תכנית החלוצים?',
    a: 'תכנית מוגבלת ל-20 בתי כנסת ראשונים. נותנת 4 חודשים חינם ואחריהם 8 חודשים בחצי מחיר על מסלול נֵר (₪72/חודש רגיל). ללא התחייבות — ניתן לבטל בכל עת. התנאי היחיד: מילוי סקר משוב קצר פעם בחודש. כולל התקנה פיזית חינם ומיני-מחשב בפיקדון ₪250 — אם מבטלים בתום תקופת החינם ומחזירים את המכשיר, הפיקדון מוחזר במלואו. כל מסך מתאים (גם קיים), ואם צריך אינטרנט — נספק סלולרי ייעודי ב-₪12/חודש.',
  },
  {
    q: 'האם אני צריך לקנות ציוד מיוחד?',
    a: 'לא חייבים. כל מה שצריך זה מסך עם חיבור HDMI ואינטרנט — המערכת עולה בדפדפן רגיל. אם רוצים פתרון יציב לטווח ארוך, אנחנו ממליצים על מיני-מחשב ייעודי שמוגדר לחזור אוטומטית לתצוגה גם אחרי נפילת חשמל.',
  },
  {
    q: 'מה כולל מיני-המחשב שאתם מציעים?',
    a: 'מיני-מחשב ב-₪200 חד-פעמי (בעלות בלבד, ללא רווח). הוא מגיע מוגדר מראש: "נעול" לתצוגה של inorai בלבד, מתאושש אוטומטית לאחר כל הפסקת חשמל, ומנוהל מרחוק. המסך עצמו לא כלול — ניתן לרכוש בנפרד (מומלץ ~50 אינץ׳) או כחבילה מלאה יחד (₪1,000 חד-פעמי).',
  },
  {
    q: 'מה אם כבר יש לנו אינטרנט במקום?',
    a: 'אם יש רשת Wi-Fi או LAN זמינה — מושלם, אין צורך בשום דבר נוסף. כרטיס הסים (₪12/חודש) מיועד רק לבתי כנסת שאין בהם עדיין אינטרנט, ואנחנו יכולים לכלול אותו כחלק מחבילת השירות.',
  },
  {
    q: 'האם ניתן לרכוש את המסך והמחשב בנפרד?',
    a: 'כן, בהחלט — הציוד הוא שירות בלבד מצדנו. ניתן לרכוש כל ציוד עצמאית, לפתוח את הקישור, והכל עולה ועובד מיד. אנחנו מציעים את הציוד כשירות נוחות בעלות בלבד: מיני-מחשב בלבד (₪200), מיני-מחשב + מסך (₪1,000), או הכל כולל סים (₪1,000 + ₪12/חודש).',
  },
  {
    q: 'מה קורה בנפילת חשמל?',
    a: 'אם השתמשתם במיני-מחשב שלנו — הוא מוגדר לעלות אוטומטית לתצוגה ברגע שהחשמל חוזר, ללא כל התערבות אנושית. אם אתם משתמשים במחשב אחר, ייתכן שתצטרכו להפעיל ידנית.',
  },
  {
    q: 'האם ניתן לשדרג או לשנות מסלול?',
    a: 'כן — ניתן לשדרג, לשנמך, או לבטל בכל עת. אין חוזים ואין קנסות. מסלולים מחושבים לפי חודש קלנדרי.',
  },
  {
    q: 'כמה מסכים ניתן לחבר?',
    a: 'מסלול בסיסי — מסך אחד. מסלול מקצועי — עד 3 מסכים עם 3 URLs ציבוריים נפרדים. מסלול קהילה — ללא הגבלה.',
  },
  {
    q: 'כיצד עובד תקופת הניסיון?',
    a: '14 יום חינם עם גישה מלאה לכל הרכיבים — ללא כרטיס אשראי ובלי התחייבות. בתום התקופה בוחרים מסלול בתשלום או עוצרים. לא שולחים דואר זבל.',
  },
];

const FAQItem = ({ item, isOpen, onToggle }) => (
  <Box
    sx={{
      borderBottom: '1px solid rgba(30,58,95,0.08)',
      '&:first-of-type': { borderTop: '1px solid rgba(30,58,95,0.08)' },
    }}
  >
    <Box
      onClick={onToggle}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 2.5,
        cursor: 'pointer',
        gap: 2,
        '&:hover .faq-question': { color: '#9a7209' },
      }}
    >
      <Typography
        className="faq-question"
        sx={{
          fontFamily: 'Heebo, sans-serif',
          fontWeight: 600,
          fontSize: { xs: '0.95rem', md: '1rem' },
          color: isOpen ? '#9a7209' : '#1e3a5f',
          transition: 'color 0.2s ease',
          lineHeight: 1.5,
        }}
      >
        {item.q}
      </Typography>

      <Box
        sx={{
          flexShrink: 0,
          width: 28,
          height: 28,
          borderRadius: '50%',
          border: `1.5px solid ${isOpen ? '#9a7209' : 'rgba(30,58,95,0.2)'}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: isOpen ? '#9a7209' : '#1e3a5f',
          fontFamily: 'monospace',
          fontSize: '1.1rem',
          fontWeight: 300,
          lineHeight: 1,
          transition: 'all 0.2s ease',
          transform: isOpen ? 'rotate(45deg)' : 'none',
        }}
      >
        +
      </Box>
    </Box>

    <Box
      sx={{
        overflow: 'hidden',
        maxHeight: isOpen ? '300px' : '0px',
        transition: 'max-height 0.35s ease',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Heebo, sans-serif',
          fontSize: '0.92rem',
          color: '#4a5968',
          lineHeight: 1.9,
          pb: 2.5,
          maxWidth: '720px',
        }}
      >
        {item.a}
      </Typography>
    </Box>
  </Box>
);

const FAQSection = ({ onOpenModal }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <Box id="faq" sx={{ bgcolor: '#fcfbfa', py: { xs: 10, md: 14 }, px: { xs: 3, md: 6 } }}>
      <Box sx={{ maxWidth: '800px', mx: 'auto' }}>

        {/* Header */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography sx={{
            fontFamily: 'Secular One, sans-serif',
            color: '#9a7209',
            fontSize: '0.85rem',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            mb: 2,
          }}>
            שאלות ותשובות
          </Typography>
          <Typography
            component="h2"
            sx={{
              fontFamily: 'Frank Ruhl Libre, serif',
              color: '#1e3a5f',
              fontSize: { xs: '1.9rem', md: '2.5rem' },
              fontWeight: 900,
              letterSpacing: '-0.02em',
              mb: 2,
            }}
          >
            כל מה שרצית לדעת
          </Typography>
          <Typography dir="rtl" sx={{
            color: '#5a6978',
            fontFamily: 'Heebo, sans-serif',
            fontSize: '1rem',
            lineHeight: 1.8,
            direction: 'rtl',
          }}>
            לא מצאת תשובה?{' '}
            <Box
              component="span"
              onClick={() => onOpenModal?.('contact')}
              sx={{
                color: '#9a7209',
                textDecoration: 'none',
                fontWeight: 600,
                cursor: 'pointer',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              כתבו לנו
            </Box>
          </Typography>
        </Box>

        {/* FAQ list */}
        <Box>
          {FAQ_ITEMS.map((item, i) => (
            <FAQItem
              key={i}
              item={item}
              isOpen={openIndex === i}
              onToggle={() => toggle(i)}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default FAQSection;
